import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { CouponModel } from '../model/CouponModel.js';
import CampaignModel from '../../Campaign/model/CampaignModel.js';
import { PromoCodeModel } from '../model/PromoCodeModel.js';

export default {
    /**
     * @param {CouponConfigModel} params /module/Coupon/config/CouponConfigModel.js
     */
    getCouponList: function (params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiShoppingCartUrl() + '/cart/vouchers';
        // let url = 'http://localhost:3000' + '/cart/vouchers';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            let couponList = [];
            let data = res.data;
            for (let i of data) {
                let coupon = new CouponModel();
                coupon.setDataFromApi(i);
                couponList.push(coupon);
            }
            return couponList;
        }));
    },

    /**
     * @param {number} couponId campaignId
     * @returns {Observable}
     */
    redeemCoupon: function (couponId) {
        let token = Account.getToken();
        let params = {
            campaign_id: couponId,
        };
        let url = ConfigManager.getApiModuleUrl() + `/cart/coupon`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    getMyCoupon: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + `/profile/me/coupons`;
        return BzbsApi.connectBzbsGet(url, token, null)
            .pipe(map((res) => { 
                var arrCampaign = [];
                for (var i of res.data.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                return arrCampaign;
            }));
    },
    /**
     * @param {string} code code
     * @returns {Observable}
     */
    verifyPromocode: function (code) {
        let token = Account.getToken();
        let params = {
            code: code,
            codeType: "all"
        };
        let url = ConfigManager.getApiShoppingCartUrl() + `/cart/verify_promocode`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            console.log(res.data);
      
            var objPromoCode = new PromoCodeModel(res.data);
            return objPromoCode;
        }));
    },
}
